import React, { useState } from "react";
import {
  TableContainer,
  Table,
  TableHead,
  TableCell,
  TableBody,
  TableRow,
} from "@mui/material";
import PropTypes from "prop-types";
import organizationService from "services/organizationService";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import lockIcon from "assets/images/lockimage.svg";
import CheckboxComponent from "components/CheckboxComponent/CheckboxComponent";
import { multipleCheckBoxCheckedHandler } from "utils/MultipleCheckboxes";
import { ModalComponent } from "components/ModalComponent";
import { OrganizationDetailsForm } from "components/Forms";
import AlertComponent from "components/AlertComponent";
import tagAdminConstants from "constants/tagAdminConstants";

import noPicture from "./no-picture.svg";

function OrganizationTable({
  organization,
  isExport,
  setAllOrganization,
  setMultipleSelectData,
}) {
  const [openModal, setOpenModal] = useState(false);
  const [orgWithUser, setOrgWithUser] = useState({});
  const [orgSingle, setOrgSingle] = useState({});

  const [state, setState] = useState({
    emailAlertError: false,
    elailAlertSuccess: false,
    resetPosswordAlertError: false,
    resetPosswordAlertSuccess: false,
    lockUserAlertError: false,
    lockUserAlertSuccess: false,
    deleteUserAlertError: false,
    deleteUserAlertSuccess: false,
    alertStatename: "",
    mesage: "",
    varient: "",
  });
  const openAlertModel = (statename, message, variant, alertstateName) => {
    setState((prev) => ({
      ...prev,
      [statename]: true,
      mesage: message,
      varient: variant,
      alertStatename: alertstateName,
    }));
  };
  const closeAlertModel = (statename) => {
    setState((prev) => ({
      ...prev,
      [statename]: false,
    }));
  };

  const organizationModalOpen = (org) => {
    organizationService
      .getOrgWithUser(org.id)
      .then((res) => {
        if (res.status === 200) {
          setOrgWithUser(res.data);
          setOrgSingle(org);
          setOpenModal(true);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <div className="b-organization-listing">
      <AlertComponent
        title={state.mesage}
        msg={state.varient}
        handleCloseAlert={() => closeAlertModel(state.alertStatename)}
        openAlert={state[state.alertStatename]}
      />
      <ModalComponent
        title={orgSingle.title ?? ""}
        openModal={openModal}
        isLocked={orgSingle.is_blocked}
        handleCloseModal={() => setOpenModal(false)}
        ModalBody={
          <OrganizationDetailsForm
            fetchAllApiData={organizationModalOpen}
            org={orgWithUser}
            orgWithUser={orgWithUser}
            handleCloseModal={() => setOpenModal(false)}
            openAlertModel={openAlertModel}
          />
        }
      />
      <TableContainer>
        <Table aria-label="collapsible table">
          <TableHead className="b-organization-listing__head">
            <TableRow>
              {isExport === true && (
                <TableCell className="dafault-font-family-bold">
                  <CheckboxComponent
                    handleCheckboxEvent={(e) => {
                      multipleCheckBoxCheckedHandler(
                        organization,
                        setAllOrganization,
                        setMultipleSelectData,
                        e
                      );
                    }}
                    checkState={
                      !organization.some((user) => user?.isChecked !== true)
                    }
                    name="allselect"
                  />
                </TableCell>
              )}
              <TableCell className="font-bold b-organization-listing__cell" />
              <TableCell
                className="remove font-bold  b-organization-listing__cell"
                align="left"
              >
                <span className="b-organization-listing__name">Name</span>
              </TableCell>
              <TableCell className="remove font-bold  b-organization-listing__cell">
                <span className="b-organization-listing__name">
                  Primary Email
                </span>
              </TableCell>

              <TableCell
                className="font-bold b-organization-listing__cell"
                align="left"
              />
            </TableRow>
          </TableHead>
          <TableBody className="index-organization-table">
            {organization.map((org) => (
              <TableRow>
                {isExport === true && (
                  <>
                    <TableCell>
                      <CheckboxComponent
                        handleCheckboxEvent={(e) => {
                          multipleCheckBoxCheckedHandler(
                            organization,
                            setAllOrganization,
                            setMultipleSelectData,
                            e
                          );
                        }}
                        checkState={org?.isChecked || false}
                        name={org.id}
                      />
                    </TableCell>
                    <TableCell>
                      <img
                        className="b-organization-listing__imge"
                        src={`${org.logo ? org.logo : noPicture}`}
                        alt=""
                        onError={({ currentTarget }) => {
                          // eslint-disable-next-line
                          currentTarget.onerror = null; // prevents looping
                          // eslint-disable-next-line
                          currentTarget.src = noPicture;
                        }}
                      />
                    </TableCell>
                  </>
                )}
                {isExport === false && (
                  <TableCell>
                    <div className="b-org-img-wrap">
                      <img
                        className={`b-organization-listing__img ${
                          !org.logo ? "no-picture" : ""
                        }`}
                        src={org.logo ? org.logo : noPicture}
                        alt=""
                        onError={({ currentTarget }) => {
                          // eslint-disable-next-line
                          currentTarget.onerror = null; // prevents looping
                          // eslint-disable-next-line
                          currentTarget.src = noPicture;
                        }}
                      />
                      {org.is_blocked === true && (
                        <div className="b-org-img-wrap-overlay">
                          <img src={lockIcon} alt="noImage" />
                        </div>
                      )}
                    </div>
                  </TableCell>
                )}
                <TableCell>
                  <span className="b-organization-listing__org-title">
                    {org.title}
                  </span>
                </TableCell>
                <TableCell className="remove dafault-font-family">
                  <span className="b-organization-listing__org-email">
                    {org.email}
                  </span>
                </TableCell>
                <TableCell className="remove dafault-font-family">
                  <span className="b-organization-listing__org-ryoe">
                    {org.organization_type ===
                    tagAdminConstants.APP_MODE.FULL.key
                      ? tagAdminConstants.APP_MODE.FULL.value
                      : tagAdminConstants.APP_MODE.LIGHT.value}
                  </span>
                </TableCell>
                <TableCell className="remove dafault-font-family">
                  <span className="b-organization-listing__org-email">
                    {org.sub_domain}
                  </span>
                </TableCell>
                {/* //moreIcons */}
                {isExport === false && (
                  <TableCell className="dafault-font-family-bold">
                    <div>
                      <MoreVertIcon
                        onClick={() => organizationModalOpen(org)}
                      />
                    </div>
                  </TableCell>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}

OrganizationTable.propTypes = {
  organization: PropTypes.oneOfType([PropTypes.object]).isRequired,
  isExport: PropTypes.bool.isRequired,
  setAllOrganization: PropTypes.func.isRequired,
  setMultipleSelectData: PropTypes.func.isRequired,
  // organizationModalOpen: PropTypes.func.isRequired,
};

export default OrganizationTable;
